<!--page-wrapper Start-->
@if(isBrowser) {
   <div class="page-wrapper">
      <router-outlet></router-outlet>
   </div>
}
<!--page-wrapper Ends-->